import type { TrackErrorBody } from '~~/server/api/prometheus/track-error.post';

export function usePrometheus() {
	const { ciCommitSHA } = useRuntimeConfig().public;

	async function trackErrorPageRender(path: string, errorCode?: number) {
		try {
			const { error } = await useFetch('/api/prometheus/track-error', {
				method: 'POST',
				body: {
					errorCode: errorCode || 500,
					path: path || window.location.pathname,
					ciCommitSHA
				} satisfies TrackErrorBody
			});

			if (error.value) {
				console.error('Failed to track error:', error.value);
			}
		} catch (e) {
			console.error('Failed to track error:', e);
		}
	}

	return {
		trackErrorPageRender
	};
}
